module.exports = __webpack_public_path__ + "static/media/IS.ade4ead4.png";